'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 *
 * Usage:
 *
 * ```Javascript
 * <SiteNavigation>
 * 	{ Children }
 * </SiteNavigation>
 * ```
 *
 * @extends {React.Component}
 */
class SiteNavigation extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      'SiteNavigation': true,
      'SiteContent-navigation': true
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <nav className={this.getClassName()}>
        { this.props.children }
      </nav>
    );
  }
}

export default SiteNavigation;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteNavigation/siteNavigation.jsx